import { useSelector } from 'react-redux'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import InputCustom from '../../../components/atoms/input/InputCustom'
import { toastHelper } from '../../../util/toastHelper'

function Budget({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const accountType = useSelector((state) => state.auth.accountType)

	const handleBackClick = () => {
		// If kazoo-planner and we showed task list, go back to task list
		if (accountType === 'kazoo-planner' && weddingData._showedTaskList) {
			setWeddingData({
				...weddingData,
				_returnToTaskList: true
			})
			handleBack(1)
		} else {
			// Regular user or planner who didn't see task list - go back to Planning
			handleBack(1)
		}
	}

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={handleBackClick}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a budget in mind?</h2>
					<p>Enter your budget below</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								<InputCustom
									placeholder="CAD $"
									name="budget"
									setDataFunction={setWeddingData}
									data={weddingData}
									value={weddingData.budget}
									type="number"
								/>
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.budget || weddingData.budget <= 0)
							return toastHelper('Budget is required', 'error')
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.5} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default Budget
